<template>
  <div class="sky-upload">
    <div class="title">Edit {{ type | typeLabel }}</div>
    <progress-bar v-if="canEdit" :progress="progress"/>
    <transition name="fade" mode="out-in">
      <component v-if="!loading" :is="currentSkyComponent" v-bind="currentProperties" @input="updateFields" @next="goNext" @back="goBack" :viewonly="!canEdit" />
    </transition>
  </div>
</template>

<script>
import SkyService from '@/services/SkyService'
import ProgressBar from '@/components/ProgressBar.vue'
import SkyLanguage from '@/views/SkyLanguage.vue'
import SkyReview from '@/views/SkyReview.vue'
import SkyDone from '@/views/SkyDone.vue'
import skyFields from '@/testdata/skyFields'
// import { LOAD_ACTIVE_MEDIA } from '@/store/actions.type'
// import { RESET_ACTIVE_MEDIA } from '@/store/mutations.type'

export default {
  name: 'sky-edit',
  components: {
    ProgressBar,
    SkyLanguage,
    SkyReview,
    SkyDone
  },
  data() {
    return {
      state: 'en-US',
      // objectId: null,
      loading: true,
      fields: skyFields
    }
  },
  computed: {
    type() {
      return this.$route.params.type
    },
    typeCamel() {
      return this.type.replace(/-([a-z])/g, function (g) { return g[1].toUpperCase(); });
    },
    objectId() {
      return this.$route.params.id
    },
    canEdit() {
      return this.$store.getters.canEdit
    },
    currentSkyComponent() {
      if (['en-US','en-CA','fr-CA','es-MX'].indexOf(this.state) > -1) {
        return 'sky-language'
      } else {
        return this.state ? ('sky-' + this.state.toLowerCase()) : null
      }
    },
    currentProperties() {
      if (this.currentSkyComponent === 'sky-language') {
        return {
          language: this.state,
          fields: this.fields[this.typeCamel][this.state]
        }
      } else if (this.currentSkyComponent === 'sky-review') {
        return {
          languageFields: this.fields[this.typeCamel],
          type: this.type,
          typeCamel: this.typeCamel
        }
      }
      return {}
    },
    progress() {
      switch (this.state) {
        case 'en-US': return 1 / 6
        case 'en-CA': return 2 / 6
        case 'fr-CA': return 3 / 6
        case 'es-MX': return 4 / 6
        case 'review': return 5 / 6
        case 'done': return 1
        default: return 0
      }
    },
  },
  watch: {
    '$route.params.page': function(page) {
      if (page) this.state = page
      else this.state = 'en-US'
    },
    progress(value) {
      if (!value) this.$router.replace('/')
    }
  },
  methods: {
    goNext(state) {
      let newState = state
      if (!newState) {
        const index = this.statePath.indexOf(this.state)
        if (index + 1 >= this.statePath.length) newState = this.endState
        else newState = this.statePath[index + 1]
      }
      this.$router.push(`/sky/${this.type}/${this.objectId}/${newState}`)
    },
    goBack() {
      if (this.state === 'en-US') {
        this.$router.push(`/sky/${this.type}`)
      } else if (this.statePath) {
        let newState = 'en-US'
        const index = this.statePath.indexOf(this.state)
        if (index - 1 < 0) newState = 'en-US'
        else newState = this.statePath[index - 1]
        this.$router.push(`/sky/${this.type}/${this.objectId}/${newState}`)
      }
    },
    updateFields(fields) {
      this.fields = fields
    }
  },
  filters: {
    typeLabel(type) {
      const camel = type.replace(/-([a-z])/g, function (g) { return ' ' + g[1].toUpperCase(); });
      return camel[0].toUpperCase() + camel.substr(1)
    }
  },
  created() {
    const loader = this.$loading.show()
    SkyService.getSkyObject(this.type, this.objectId)
      .then(({ data }) => {
        if (data && data.default && data.languages) {
          for (const language in skyFields[this.typeCamel]) {
            if (this.fields[this.typeCamel].hasOwnProperty(language)) {
              const fields = this.fields[this.typeCamel][language];
              fields.forEach(field => {
                if (data.languages[language] && data.languages[language][field.id]) {
                  field.value = data.languages[language][field.id]
                } else if (language === 'en-US') {
                  field.value = data.default[field.id]
                } else {
                  field.value = null
                }
              })
            }
          }
        }
        loader.hide()
        this.$nextTick(() => {
          this.loading = false
        })
      })
      .catch(() => {
        window.alert('There was an error getting the Sky Object. Please refresh to try again.')
        loader.hide()
      })
    this.endState = 'done'
    this.statePath = ['en-US','en-CA','fr-CA','es-MX','review']
    let loadState = this.$route.params.page ? this.$route.params.page : 'en-US'

    if (!this.canEdit) {
      loadState = 'review'
      this.$router.replace(`/sky/${this.type}/${this.objectId}/review`)
    }
    
    // this.loading = true
    // const loader = this.$loading.show()
    // this.$store.dispatch(LOAD_ACTIVE_MEDIA, this.mediaID)
    // .finally(() => {
    //   this.state = loadState
    //   this.startState = loadState
    //   this.loading = false
    //   loader.hide()
    // })
    if (!this.$route.params.page) {
      this.$router.replace(`/sky/${this.type}/${this.objectId}/${this.loadState}`)
    }
    // this.loading = false
    this.state = loadState
    this.startState = this.state
  }
}
</script>

<style lang="scss" scoped>
.fade-enter-active, .fade-leave-active {
  transition: opacity 300ms;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
.title {
  font-weight: 600;
  text-transform: uppercase;
  margin-bottom: 14px;
}
.sky-upload {
  text-align: center;

  /deep/ header {
    display: flex;
    align-items: center;
    margin-bottom: 45px;

    .flow-btn {
      text-align: left;
      flex: 0 0 20%;
    }

    .title {
      margin: auto;

      h1 {
        margin-bottom: em(7, 32);

        & + p {
          margin: 0;
        }
      }

      & + .flow-btn {
        text-align: right;
      }
    }
  }
}
</style>
